var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed z-50 bottom-[60px] lg:bottom-[82px] right-[8px] lg:right-[20px] w-[54px] lg:w-[64px] py-[12px] lg:py-[24px] text-center text-[#666] bg-white rounded-[12px]",
      staticStyle: { "box-shadow": "0px 0px 12px 0px rgba(0,0,0,0.05)" },
    },
    [
      _c(
        "div",
        { staticClass: "hover:text-[#3e90ff] relative cursor-pointer" },
        [
          _c(
            "a-popover",
            { attrs: { placement: "left" } },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  { staticClass: "lg:block p-[4px] rounded-[8px] bg-white" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "mt-[5px] mb-[3px] text-center text-[16px] text-[#666] leading-[26px]",
                      },
                      [
                        _c("span", [_vm._v("白工：")]),
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-[#3e90ff] tracking-wide text-[18px]",
                          },
                          [_vm._v(_vm._s(_vm.phone))]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _c("div", [
                _c(
                  "span",
                  { staticClass: "text-[22px]" },
                  [_c("a-icon", { attrs: { type: "phone" } })],
                  1
                ),
                _c(
                  "p",
                  {
                    staticClass:
                      "pt-[6px] pb-[20px] lg:pt-[8px] lg:pb-[22px] text-[10px] lg:text-[12px] leading-[14px]",
                  },
                  [_vm._v(" 电话咨询 ")]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hover:text-[#3e90ff] relative cursor-pointer" },
        [
          _c(
            "a-popover",
            { attrs: { placement: "left" } },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  { staticClass: "lg:block p-[4px] rounded-[8px] bg-white" },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                          width: "100%",
                        },
                        attrs: { id: "wl-qrcode-contact-nav" },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "160px",
                            height: "160px",
                            border: "1px solid rgb(238, 238, 238)",
                            "border-radius": "10px",
                          },
                          attrs: { src: require("@/assets/imgs/wechat.jpg") },
                        }),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "mt-[5px] mb-[3px] text-center text-[14px] text-[#666] leading-[26px]",
                      },
                      [_vm._v("微信扫一扫添加官方微信 ")]
                    ),
                  ]
                ),
              ]),
              _c("div", [
                _c(
                  "span",
                  { staticClass: "text-[22px]" },
                  [_c("a-icon", { attrs: { type: "wechat" } })],
                  1
                ),
                _c(
                  "p",
                  {
                    staticClass:
                      "pt-[6px] pb-[20px] lg:pt-[8px] lg:pb-[22px] text-[10px] lg:text-[12px] leading-[14px]",
                  },
                  [_vm._v(" 微信咨询 ")]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "hover:text-[#3e90ff] relative cursor-pointer",
          on: { click: _vm.openPage },
        },
        [
          _c(
            "span",
            { staticClass: "text-[22px]" },
            [_c("a-icon", { attrs: { type: "solution" } })],
            1
          ),
          _c(
            "p",
            {
              staticClass:
                "pt-[6px] pb-[20px] lg:pt-[8px] lg:pb-[22px] text-[10px] lg:text-[12px] leading-[14px]",
            },
            [_vm._v(" 申请演示 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }